var React = require('react');

function CircleCheckmark (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.circle-checkmark-svg{fill:#0CB050;}\n"),React.createElement("path",{"className":"circle-checkmark-svg","d":"M7,0C3.1,0,0,3.1,0,7s3.1,7,7,7s7-3.1,7-7S10.9,0,7,0z M10.5,5.2L6,9.7C5.7,10,5.3,10,5,9.7L3.5,8.2\n\tC3.2,8,3.2,7.6,3.5,7.3s0.7-0.3,1,0l1,1l4-4c0.3-0.3,0.7-0.3,1,0C10.7,4.5,10.7,5,10.5,5.2z","key":1})]);
}

CircleCheckmark.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 14 14","style":{"enableBackground":"new 0 0 14 14"},"xmlSpace":"preserve","width":"14","height":"14"};

module.exports = CircleCheckmark;

CircleCheckmark.default = CircleCheckmark;
